// captureScreen → JPEG bytes (plan 4.3). The panel writes a file; we read it and delete it.
import type {SignagePanel} from "../SignagePanel.ts";

export class ScreenCapture {
    constructor(private readonly panel: SignagePanel) {}

    async captureJpeg(): Promise<Uint8Array> {
        const path = await this.panel.captureScreen();
        try {
            return await this.panel.readFile(path);
        } finally {
            await this.panel.deleteFile(path);
        }
    }
}
